export enum ChartBlock {
  Root = 'Chart',
}

export enum ChartElement {
  Title = 'title',
  Filters = 'filters',
  Chart = 'chart',
}
